module.exports = __webpack_public_path__ + "static/media/freight.8a54a907.png";